import { useDisplayTimezone } from "hooks/useTimezone";
import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import { InstantDoubleValue } from "api/model/dataset/InstantDoubleValue";
import React, { JSX } from "react";
import { T } from "services/lang/LanguageService";
import { DataDisplayType, DiffValueOptions } from "./ValueChangeIndicatorTypes";
import DiffRow from "./DiffRow";

interface DiffRowProps {
  prevInfo?: JSX.Element;
  currInfo?: JSX.Element;
  currentDiffValueOptions: DiffValueOptions;
  currentData?: InstantDoubleValue[];
  currentDataset?: DatasetDataInfoResponse;
  dataDisplayType: DataDisplayType;
  diffDecimalPlaces?: number;
}

const DiffTooltip = ({
  prevInfo,
  currInfo,
  currentDiffValueOptions,
  currentData,
  currentDataset,
  dataDisplayType,
  diffDecimalPlaces,
}: DiffRowProps) => {
  const displayTz = useDisplayTimezone();

  if (dataDisplayType === DataDisplayType.MONTH_YEAR_COMPARISON) {
    return (
      <div className="flex flex-column gap-1">
        <div>{prevInfo}</div>
        <div>{currInfo}</div>
      </div>
    );
  }
  if (dataDisplayType === DataDisplayType.HORIZONTAL_BAR_CHART) {
    return (
      <div className="flex flex-column gap-1">
        <div>{currentDiffValueOptions.previousValueInfo}</div>
        <div>{currentDiffValueOptions.currentValueInfo}</div>
      </div>
    );
  }
  if (currentData?.[0] && currentData?.[1] && currentDataset) {
    return (
      <div className="flex flex-column gap-1">
        {currentData[0].value && (
          <DiffRow
            label={T("word.previous-value")}
            value={currentData[0].value}
            unit={currentDataset.unit}
            timestamp={currentData[0].key}
            diffDecimalPlaces={diffDecimalPlaces}
            tz={displayTz}
          />
        )}
        {currentData[1].value && (
          <DiffRow
            label={T("word.current-value")}
            value={currentData[1].value}
            unit={currentDataset.unit}
            timestamp={currentData[1].key}
            diffDecimalPlaces={diffDecimalPlaces}
            tz={displayTz}
          />
        )}
      </div>
    );
  }
  return <div>{T("word.no-data")}</div>;
};

export default DiffTooltip;
